<template>
  <v-container fluid style="height: 100vh; max-width: 600px">
    <v-layout column fill-height>
      <v-row class="flex-grow-0">
        <v-toolbar dense elevation="0">
          <v-icon class="pr-1" dense>event_available</v-icon>
          <v-btn rounded text style="font-size: 110%; padding: 0 5px" @click="selectVehicle">{{ vehicle.numericPlate
            }}
          </v-btn>
          <v-spacer></v-spacer>

          <!-- výběr měsíce -->
          <v-menu
            ref="monthMenu"
            v-model="monthMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            nudge-left="100"
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                style="font-weight: bold"
                color="transparent"
                v-bind="attrs"
                v-on="on"
              >{{ formatMonth(month) }}
              </v-chip>
            </template>
            <v-date-picker
              v-model="month"
              @input="monthMenu = false"
              type="month"
              :max="getCurrenDateInMS()"
              no-title
              scrollable
              :locale="getIsoLocale()"
            >
            </v-date-picker>
          </v-menu>

          <!-- export do PDF
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="toReportLogbook" small class="pr-2" v-bind="attrs" v-on="on">
                <v-icon>mdi-file-chart-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.logbook.tooltip.report_logbook") }}</span>
          </v-tooltip>
          -->

          <v-menu offset-y z-index="4000">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom open-delay="500">
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    small
                    icon
                    class="mr-1"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-icon>list</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("map.panel.online.tooltip.more") }}</span>
              </v-tooltip>
            </template>
            <v-list>
              <template v-for="etype in eventsList">
                <v-list-item
                  :key="etype"
                  link
                  @click="paremeterFilterChange(etype)"
                >
                  <v-list-item-action><v-checkbox :input-value="parameterSelected(etype)"/></v-list-item-action>
                  <v-list-item-title>{{ $t("enum.parameters." + etype) }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>

          <v-divider vertical class="my-2" inset />

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionVehicle" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-crosshairs-gps</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.vehicle") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionHistory" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.history") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionLogbook" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>mdi-text-box-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.logbook") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionRefueling" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>local_gas_station</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.refueling") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionService" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>build</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.service") }}</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="500" v-if="canRead('contract')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="actionContracts" v-bind="attrs" v-on="on" small class="ma-1">
                <v-icon>widgets</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.contracts") }}</span>
          </v-tooltip>

          <v-divider vertical class="my-2" inset />

          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="closeLogbook" v-bind="attrs" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("map.panel.tooltip.close") }}</span>
          </v-tooltip>

        </v-toolbar>
      </v-row>
      <v-row class="overflow-hidden" style="max-height: 100%">
        <v-data-table style="max-height: 100vh; width: 600px"
                      :items="events"
                      item-key="name"
                      class="elevation-0 row-height-event map-table"
                      hide-default-header
                      hide-default-footer
                      fixed-header
                      :items-per-page="-1"
                      height="95vh"
        >
          <template v-slot:header="">
            <thead>
            <tr>
              <th>{{ $t("map.panel.events.column.ts") }}</th>
              <th>{{ $t("map.panel.events.column.event") }}</th>
              <th>{{ $t("map.panel.events.column.state") }}</th>
              <th>{{ $t("map.panel.events.column.person") }}</th>
            </tr>
            </thead>
          </template>
          <template v-slot:item="props">
            <tr v-on:click="rowClick(props.item)"
                v-on:contextmenu="rowMenuClick($event, props.item)"
                v-bind:class="{'yellow lighten-4': $store.state.events.event !== null && props.item.timestamp === $store.state.events.event.timestamp && props.item.parameterId === $store.state.events.event.parameterId}">
              <td style="white-space: nowrap">{{ formatDate(props.item.timestamp) }}</td>
              <td style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 310px">
                {{ formatParameter(props.item.parameterId) }}
              </td>
              <td style="white-space: nowrap;">{{ formatParameterValue(props.item.parameterId, props.item.measureValue) }}</td>
              <td style="white-space: nowrap;">{{ formatName(props.item.person) }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-menu
          v-model="contextMenu"
          :position-x="contextMenuX"
          :position-y="contextMenuY"
          absolute
          offset-y
        >
          <v-list>
            <v-list-item v-for="(item, index) in getRideContextMenuItems(contextEvent)"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { DateTime } from "luxon";
import utils from "@/utils";
import i18n from "@/plugins/i18n";

export default {
  name: "SideEvents",

  props: {
    vehicleSidebarClick: {}
  },

  data() {
    return {
      monthMenu: false,
      month: null,

      eventsList: [ "panic", "cargo_door", "motor_on" ],

      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextEvent: null
    };
  },

  methods: {
    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextEvent = item;
      this.contextMenu = true;

      event.preventDefault();
    },

    getRideContextMenuItems(event) {
      let menu = [];

      if (event !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.events.context_menu.select") });
      }

      return menu;
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "select":
          this.rowClick(this.contextEvent);
          break;
        case "update":
          this.$store.dispatch("dialogs/showDialog", { dialog: "rideUpdate", options: this.contextEvent });
          break;
      }
    },

    selectVehicle() {
      this.$store.dispatch("dialogs/showDialog", {
        dialog: "vehicleSelection", options: true
      });
    },

    getEventContextMenuItems(ride) {
      let menu = [];

      if (ride !== null) {
        menu.push({ name: "select", title: this.$t("map.panel.logbook.ride_menu.select") });
        if (ride.rideState !== "unfinished" && this.accessRole("admin"))
          menu.push({ name: "update", title: this.$t("map.panel.logbook.ride_menu.update") });
      }

      return menu;
    },

    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").plus({ "days": 1 }).toISO();
    },

    formatMonth(date) {
      if (date !== null)
        return DateTime.fromFormat(date, "yyyy-M").toLocaleString({ month: "long", year: "numeric" });
      else
        return "";
    },

    paremeterFilterChange(param) {
      const paramCodes = (this.$store.state.events.paramCodes.includes(param))
        ? this.$store.state.events.paramCodes.filter(x => x !== param)
        : [...this.$store.state.events.paramCodes, param];

      this.$store.dispatch("events/fetch", {
        periodFrom: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        periodTo: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'"),
        paramCodes: paramCodes
      });
    },

    parameterSelected(param) {
      return this.$store.state.events.paramCodes.includes(param);
    },

    rowClick(e) {
      this.$store.dispatch("events/fetch", {
        periodFrom: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        periodTo: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'"),
        timestamp: e.timestamp,
        parameterId: e.parameterId
      });

      this.$emit("clicked", e);
    },

    closeLogbook() {
      this.$store.dispatch("events/clear");
      this.$router.routeToMap();
    },

    actionHistory() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/history",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    actionLogbook() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/logbook",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionRefueling() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/refueling",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionContracts() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/contracts",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId },
        query: { month: this.month }
      });
    },

    actionService() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/service",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    actionVehicle() {
      let vehicleId = this.vehicle.vehicleId;
      this.$router.replace({
        name: "map/vehicle",
        params: { ccode: this.$store.state.auth.company.code, id: vehicleId }
      });
    },

    toReportLogbook() {
      this.$router.push({
        name: "report/logbook", query:
          {
            vehicleId: this.event.vehicleId,
            period: "month-one|" + DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM")
          }
      });
    },

    formatDate(tm) {
      return DateTime.fromISO(tm).toFormat("d.M. H:mm");
    },

    formatParameter(id) {
      const p = this.$store.getters["data/getParameter"](id);

      if (p !== undefined) {
        return this.$t("enum.parameters." + p.code);
      }

      return "-";
    },

    formatParameterValue(id, value) {
      const p = this.$store.getters["data/getParameter"](id);

      if (p !== undefined) {
        return this.$t("param_names." + value + "." + p.code);
      }

      return "-";
    },

    formatName(personName) {
      if (personName !== undefined && personName !== null) {
        if (personName.firstName !== null)
          return personName.firstName + " " + personName.lastName;
        else
          return personName.lastName;
      } else
        return "-";
    },

    refreshEvents() {
      return this.$store.dispatch("events/fetch", {
        periodFrom: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        periodTo: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'")
      });
    },

    updateUrl() {
      this.$router.replace({
        name: "map/events",
        params: {
          id: this.$store.state.events.vehicle.vehicleId
        },
        query: {
          ...this.$route.query,
          month: this.month,
          event: (this.$store.state.events.event != null)
            ? this.$store.state.events.event.timestamp + "@" + this.$store.state.events.event.parameterId
            : undefined
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    month: function() {
      this.refreshEvents().then(() => this.updateUrl());
    },

    "$store.state.events.event": function() {
      this.updateUrl();
    },

    "$store.state.events.events": function() {
      this.updateUrl();
    }
  },

  computed: {
    vehicle() {
      return this.$store.state.events.vehicle;
    },

    events() {
      return this.$store.state.events.events;
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchCodes", "parameters");

    this.month = utils.notNullValueOtherNull(this.$route.query["month"], DateTime.now().toFormat("yyyy-M"));
  }
};
</script>

<style lang="sass" scoped>
.list-item-content
  padding: 4px 0 !important

.icon
  padding: 0 5px 0 0 !important
  color: steelblue !important

.list-item-subtitle
  padding: 1px 0 !important
  font-size-adjust: 0.48

.selected
  background: #d3e6e9

.list-item-content-edit
  padding: 4px 0 10px 0 !important

.v-data-table.row-height-event td
  height: 30px !important

</style>